module.exports = __webpack_public_path__ + "static/media/2mobile.e099ad03.webp";